module.exports = __webpack_public_path__ + "img/xinzhuang.757110df.jpg";